const regionModal = document.querySelector('.select-region');

if (regionModal && !Cookies.get('region_selected') && !regionModal.classList.contains('is-open-select-region')) {
  setTimeout(() => {
    regionModal.classList.add('is-open-select-region');
  }, 1000);
}

// Close button → set cookie + prevent auto open
if (regionModal) {
  attachEvent('[data-language-submit]', 'click', (ev) => {
    const button = ev.target.closest('.btn');

    if (button.classList.contains('btn--disabled')) {
      return;
    }

    Cookies.set('region_selected', true, { expires: 365 });
    regionModal.classList.remove('is-open-select-region');
  });
}
